import script from "./WhatIsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatIsItem.vue?vue&type=script&setup=true&lang=js"

import "./WhatIsItem.vue?vue&type=style&index=0&id=17810d4c&lang=scss"

const __exports__ = script;

export default __exports__